import { BaseFailureCodes } from "src/repositories/api/Utils/ResponseUtility";
import FailableResponse, { FailedResponse } from "src/repositories/model/FailableResponse";
import authService from "../core/auth/Auth.service";
import { reduxStore } from "../redux/ReduxStore";
import tokenUnauthorizedSlice from "../redux/slices/miscellaneous/TokenUnauthorizedSlice";

export function handleGeneralErrorResponse(
  failedResponse: FailedResponse<BaseFailureCodes | any, any>
): void {
  if (failedResponse.code == "unauthorized") {
    if (reduxStore.getState().token != null) {
      authService.logout();
      reduxStore.dispatch(tokenUnauthorizedSlice.actions.update(true));
    }
  }
}

// TODO: test this function
export function methodWrapper<T extends (...arg: any) => any>(
  inputFunction: T,
  postAction?: (input: ReturnType<T>) => ReturnType<T>
): T {
  return ((...args: Parameters<T>) => {
    const result: ReturnType<T> = inputFunction(args);
    return postAction?.(result) ?? result;
  }) as any;
}

export async function handleGeneralErrorPostAction<
  T extends Promise<FailableResponse<any, any, any>>
>(input: T): Promise<Awaited<T>> {
  const result = await input;
  if (!result.success) {
    handleGeneralErrorResponse(result);
  }
  return result;
}